import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "이름, 연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        path: sessionStorage.getItem("path"),
        type: 1,
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="hidden xl:flex items-center gap-5 fixed left-0 bottom-5 w-full h-fit py-2 px-[calc((100%-var(--container))/3)] 3xl:px-[calc((100%-var(--container)-150px))] z-40">
      <div className=" relative w-full h-full bg-gradient-to-l from-[#8ADEFF] to-[#56BDFF] border-2 border-[#188CD1] flex mx-auto items-center gap-3 2xl:gap-5 rounded-full px-10 py-2 shadow-md">
        <div className="relative w-fit h-full flex items-center gap-3 2xl:gap-6">
          <div className="relative w-fit h-full text-white">
            <h3 className="font-light">
              SOS&nbsp;도어락열쇠프로&nbsp;간편문의
            </h3>
          </div>
          <div className=" relative w-1 h-8 border-r"></div>
        </div>
        <div className=" relative w-fit h-full min-w-[600px] grid grid-cols-2 gap-3 2xl:gap-5">
          <div className="relative w-full h-full flex items-center gap-3">
            <p className="text-white leading-0 mt-1.5 lg:text-2xl">이름</p>
            <div className="relative w-full h-full">
              <label
                htmlFor="name1"
                className=" absolute left-1.5 z-10 top-2 lg:text-lg"
              >
                이름
              </label>
              <input
                type="text"
                value={name}
                className="!pl-12"
                id="name1"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="relative w-full h-full flex items-center gap-3">
            <p className="text-white leading-0 mt-1.5 lg:text-2xl">연락처</p>
            <div className="relative w-full h-full">
              <label
                htmlFor="phone1"
                className=" absolute left-1.5 z-10 top-2 lg:text-lg"
              >
                연락처
              </label>
              <input
                className="!pl-16"
                type="text"
                id="phone1"
                value={phone}
                maxLength={11}
                onChange={(e) =>
                  setPhone(
                    e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                  )
                }
              />
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={handlerPostContact}
          disabled={loading}
          className=" relative w-fit h-fit py-1 px-8 bg-point text-primary rounded-full"
        >
          <h4 className="font-light">전송하기</h4>
        </button>
      </div>

      <button
        type="button"
        onClick={() => window.open("https://open.kakao.com/o/sFNr9vch")}
        className="w-fit h-fit hidden 2xl:block hover:-translate-y-2 transition-transform duration-200"
      >
        <img src="/images/iconKakao.png" alt="icon" width={70} height={70} />
      </button>
    </div>
  );
};

export default QuickBar;
